// extracted by mini-css-extract-plugin
module.exports = {"cardActionArea":"GridRestaurantCard_cardActionArea__2xeNN","cardImage":"GridRestaurantCard_cardImage__3di5Y"};